import { render, staticRenderFns } from "./UserSysteamInterestDelete.vue?vue&type=template&id=6d6665cd&"
import script from "./UserSysteamInterestDelete.vue?vue&type=script&lang=js&"
export * from "./UserSysteamInterestDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports